import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const TableFilter = ({dataObject, searchFilter, setFilteredData, columnSetting, columnSettings, setColumnSettings, ...props}) => {
    let contentArray =  dataObject === null? [] : columnSetting.filter.getColumnData(columnSetting, dataObject);


    const [options, ] = React.useState(
      contentArray.map(content => {
        return {
         label: content.toString()
        }
     })
    );

    return (
    <Autocomplete
        freeSolo
        sx={{ minWidth: 400, width: '100%' }}
        fullWidth
        options={options}
        onInputChange={(event, value, reason) => {
          columnSetting.filter.value = value ? value: null;
          setColumnSettings({...columnSettings});
        }}    
        value={columnSetting.filter.value}  
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search"
            placeholder="Type to search..."
          />
        )}
    />
    );    
}
export default TableFilter;